import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import { OffersPage } from './OffersPage';
import { OfferEditorPage } from './OfferEditorPage';
import { OfferDetailPage } from './OfferDetailPage';
import { CompanyProfilePage } from './CompanyProfilePage';
import type { BackofficeModule } from '../registry';

/** Bausteine für andere Seiten: Angebote zur Anfrage und zum Kontakt, die öffentliche Seite für den Kunden (main.tsx) */
export { RelatedOffers } from './RelatedOffers';
export { PublicOfferPage } from './PublicOfferPage';
/** Positionen, Summen und Empfänger, die auch die Aufträge (KON-125) nutzen */
export { draftFromLine, emptyLine, LinesEditor, LinesView, linesBody, linesProblem, useUnits, type LineDraft } from './LinesEditor';
export { RecipientCard } from './RecipientCard';

/**
 * Einstiegspunkt des Moduls „Angebote“ im Backoffice (KON-034). Alles dazu liegt in diesem Ordner. Das Backoffice kennt nur diese Datei (siehe registry.tsx).
 * Die Verträge zur API stehen in packages/shared/src/offers.
 */
export const offersModule: BackofficeModule = {
  key: 'offers',
  path: '/angebote',
  // Die Firmendaten pflegt der Mandant in der Einrichtung. Sie gelten für das ganze Unternehmen, deshalb stehen sie unter „Allgemein“ und setzen das Modul nicht voraus.
  // Den früheren Leistungskatalog ersetzt seit KON-113 das Modul Produkte.
  setupSections: [
    {
      path: 'firmendaten',
      label: 'Firmendaten',
      module: 'setup',
      permission: 'setup.read',
      description: 'Anschrift, Logo, Steuernummer und Bankverbindung für den Briefkopf, dazu die Vorgabetexte der Angebote und die E-Mail beim Versand.',
      built: true,
      group: 'general',
      keywords: ['IBAN', 'BIC', 'Bank', 'USt-IdNr.', 'Steuernummer', 'Briefkopf', 'Impressum', 'Kleinunternehmer', 'Handelsregister', 'Adresse'],
    },
  ],
  setupRoutes: <Route path="firmendaten" element={<ModuleGate module="setup" permission="setup.read"><CompanyProfilePage /></ModuleGate>} />,
  routes: (
    <>
      <Route path="angebote" element={<ModuleGate module="offers" permission="offers.read"><OffersPage /></ModuleGate>} />
      <Route path="angebote/neu" element={<ModuleGate module="offers" permission="offers.write"><OfferEditorPage /></ModuleGate>} />
      <Route path="angebote/:id" element={<ModuleGate module="offers" permission="offers.read"><OfferDetailPage /></ModuleGate>} />
      <Route path="angebote/:id/bearbeiten" element={<ModuleGate module="offers" permission="offers.write"><OfferEditorPage /></ModuleGate>} />
    </>
  ),
};
